import { css } from 'styled-components';

export const menuItemStyle = css`
  color: var(--p-color-text-primary);
  padding: 20px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    cursor: pointer;
    background-color: var(--p-color-surface-1-hover);
    color: var(--p-color-text-primary-pressed);

    i {
      color: var(--p-color-text-primary-pressed);
    }
  }

  &.active {
    cursor: pointer;
    background-color: var(--p-color-background-pressed);
    color: var(--p-color-text-primary);
  }
`;
